export default __webpack_public_path__ + "assets/textarea.9662fb1a.svg";